module.exports = __webpack_public_path__ + "assets/img/btn-view-aa496c42.png";